module.exports = __webpack_public_path__ + "img/huace3.a2b75ebf.jpg";